export interface IOrderItemSubStatusSchema {
    reasons: string[];
}
